import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import Swal from 'sweetalert2';
import BootstrapVue3 from 'bootstrap-vue-3';
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';
import CKEditor from '@ckeditor/ckeditor5-vue';

import Maska from 'maska'
import { i18n } from "./i18n.js"
import { initFirebaseBackend } from './authUtils'
import { configureFakeBackend } from './helpers/fake-backend';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import '../src/assets/css/myCustomStyle.css';

import store from "./state/store";

import "../src/design/app.scss";
import axios from 'axios';
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  config => {
    config.headers['X-Frontend-Url'] = window.location.href;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      Swal.fire({
        icon: 'error',
        title: 'Sesi habis',
        text: 'Sesi Anda telah berakhir. Silakan masuk kembali.',
        confirmButtonText: 'OK',
      }).then(() => {
        // Redirect to login page
        router.push('/logout');
      });
    }
    return Promise.reject(error);
  }
);

// Vue Select 
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';

const requireComponent = require.context(
  '@/router/views/master',
  true,
  /\.vue$/
);

const vueApp = createApp(App);

vueApp
  .component('v-select', vSelect)
  .use(store)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVue3)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .use(Maska)
  .use(CKEditor)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.split('/').pop().replace(/\.\w+$/, '')
    vueApp.component(
      componentName,
      componentConfig.default || componentConfig
    )
})

vueApp.mount('#app')